/**
 * Created with IntelliJ IDEA.
 * User: abahlk
 * Date: 12.07.13
 * Time: 11:16
 * To change this template use File | Settings | File Templates.
 */

import { ExternalLoggingConstants } from "../ExternalLoggingConstants";
import { AbstractLogObject } from "../logObjects/AbstractLogObject";
import { BasicLogObjectFactory } from "./BasicLogObjectFactory";

export class InstanceErrorLOFactory extends BasicLogObjectFactory {
    public static NO_INSTANCES_FOR_CURRENT_COUNTRY_FOUND: number = 12001;
    public static CONNECT_TO_INSTANCE_NULL: number = 12002;
    public static INVALID_COUNTRY_NETWORK_CONFIGURATION: number = 12003;
    public static INSTANCE_COUNTRYCODE_EMPTY_LIST: number = 12004;

    private static INSTANCE_ERROR: number = 12;

    constructor(subErrorId: number) {
        super();

        this._subErrorId = subErrorId;
    }

    public create(): AbstractLogObject {
        // Build the commonData
        let lo: AbstractLogObject = super.create();

        // Update with customData
        lo.logData.set(ExternalLoggingConstants.PARAM_LOG_EVENT_ID, InstanceErrorLOFactory.INSTANCE_ERROR.toString());

        return lo;
    }
}
